import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'welcome-user',
    computed: Object.assign({}, mapGetters('account', {
        firstName: 'firstName',
        isLogin: 'isLogin',
    })),
});
